import { Descriptions } from "antd";
import type { Category } from "../../../../../app/features/admin/admin.types";
import CustomModal from "../../../../../components/CustomModal";
import StatusTag from "../../../../../components/StatusTag";
import type { ModalType } from "../../../../../hooks/useModal";
import { formatDate } from "../../../../../utils/time.utils";

interface CategoryDetailsProps {
  open: boolean;
  onCancel: () => void;
  category?: Category | null;
  type?: ModalType["type"];
}

const CategoryDetails = ({
  open,
  onCancel,
  category,
}: CategoryDetailsProps) => {
  if (!category) return null;

  return (
    <CustomModal
      title="Category Details"
      open={open}
      handleClose={onCancel}
      footer={null}
      width={500}
    >
      <Descriptions column={1} bordered>
        <Descriptions.Item label="ID">{category.id}</Descriptions.Item>
        <Descriptions.Item label="Name">{category.name}</Descriptions.Item>
        {/* <Descriptions.Item label="Slug">{category.slug}</Descriptions.Item> */}
        <Descriptions.Item label="Sort Order">
          {category.sortOrder}
        </Descriptions.Item>
        <Descriptions.Item label="Status">
          <StatusTag
            value={category.isActive ? "active" : "inactive"}
            config={[
              { value: "active", label: "Active", className: "status-success" },
              {
                value: "inactive",
                label: "Inactive",
                className: "status-error",
              },
            ]}
          />
        </Descriptions.Item>
        <Descriptions.Item label="Created At">
          {formatDate(category.createdAt)}
        </Descriptions.Item>
        <Descriptions.Item label="Updated At">
          {formatDate(category.updatedAt)}
        </Descriptions.Item>
      </Descriptions>
    </CustomModal>
  );
};

export default CategoryDetails;
